module.exports = __webpack_public_path__ + "static/media/bookmark.00534437.svg";